import { render, staticRenderFns } from "./order.vue?vue&type=template&id=ab37294e&"
import script from "./order.vue?vue&type=script&lang=ts&"
export * from "./order.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports